import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { RouteParamsTypes, PermissionModulesEnum, PermissionActionsEnum, Modules, NonAuthRoutes } from '../enums';
import ProtectedRoute from '../components/ProtectedRoute';
import PropertyVisitList from '../modules/propertyVisits/list';
import PropertyVisitAddEditView from '../modules/propertyVisits/addEditView';

const PropertyVisits: React.FC = () => {
  return (
    <Routes>
      <Route path={RouteParamsTypes.blank} element={<ProtectedRoute component={PropertyVisitList} accessibleTo={[{ [PermissionModulesEnum.PropertyVisit]: [PermissionActionsEnum.View] }]} />} />
      <Route path={RouteParamsTypes.view + RouteParamsTypes.id} element={<ProtectedRoute component={PropertyVisitAddEditView} accessibleTo={[{ [PermissionModulesEnum.PropertyVisit]: [PermissionActionsEnum.View] }]} />} />
      <Route path={RouteParamsTypes.add} element={<ProtectedRoute component={PropertyVisitAddEditView} accessibleTo={[{ [PermissionModulesEnum.PropertyVisit]: [PermissionActionsEnum.Add] }]} />} />
      <Route path={RouteParamsTypes.edit + RouteParamsTypes.id} element={<ProtectedRoute component={PropertyVisitAddEditView} accessibleTo={[{ [PermissionModulesEnum.PropertyVisit]: [PermissionActionsEnum.Update] }]} />} />
      <Route path={RouteParamsTypes.any} element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />} />
    </Routes>
  );
};

export default PropertyVisits;
